const original_identity = [
  {
    identidad_originaria: "Afroboliviano",
  },
  {
    identidad_originaria: "Aymara",
  },
  {
    identidad_originaria: "Araona",
  },
  {
    identidad_originaria: "Ayoreo",
  },
  {
    identidad_originaria: "Baure",
  },
  {
    identidad_originaria: "Canichana",
  },
  {
    identidad_originaria: "Cavineño",
  },
  {
    identidad_originaria: "Cayubaba",
  },
  {
    identidad_originaria: "Chácobo",
  },
  {
    identidad_originaria: "Chipaya",
  },
  {
    identidad_originaria: "Chiquitano",
  },
  {
    identidad_originaria: "Esse Ejja",
  },
  {
    identidad_originaria: "Guaraní",
  },
  {
    identidad_originaria: "Guarasugwé",
  },
  {
    identidad_originaria: "Guarayo",
  },
  {
    identidad_originaria: "Itonama",
  },
  {
    identidad_originaria: "Joaquiniano",
  },
  {
    identidad_originaria: "Kallawaya",
  },
  {
    identidad_originaria: "Leco",
  },
  {
    identidad_originaria: "Machinerí",
  },
  {
    identidad_originaria: "Maropa",
  },
  {
    identidad_originaria: "Mestizo",
  },
  {
    identidad_originaria: "Mojeño",
  },
  {
    identidad_originaria: "Moré",
  },
  {
    identidad_originaria: "Mosetén",
  },
  {
    identidad_originaria: "Movima",
  },
  {
    identidad_originaria: "Murato",
  },
  {
    identidad_originaria: "Pacahuara",
  },
  {
    identidad_originaria: "Quechua",
  },
  {
    identidad_originaria: "Sirionó",
  },
  {
    identidad_originaria: "Tacama",
  },
  {
    identidad_originaria: "Tapiete",
  },
  {
    identidad_originaria: "T'simane",
  },
  {
    identidad_originaria: "Weenhayek",
  },
  {
    identidad_originaria: "Yaminahua",
  },
  {
    identidad_originaria: "Yucararé-Mojeño",
  },
  {
    identidad_originaria: "Yuki",
  },
  {
    identidad_originaria: "Yuracaré",
  },
  {
    identidad_originaria: "Otro",
  },
];
export default original_identity;
